import { useTranslation } from "react-i18next";
import {
  Avatar,
  Icon,
  InfoDrawerSection,
  ComplexListItemAccordion,
  Typography,
} from "@inductiveautomation/ws-components";

import { CourseProgressSectionProps } from "../../Training.types";
import { getHistoryStyles } from "../../_training.styles";

const CourseProgressSection = ({ progress }: CourseProgressSectionProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "training.credential.course_progress",
  });
  const { classes } = getHistoryStyles();

  return (
    <InfoDrawerSection heading={t("heading")} fullWidth hasDivider={false}>
      <div className={classes.root}>
        <ComplexListItemAccordion
          showShadow={false}
          groupItems={progress.map((course) => ({
            id: course.id,
            avatar: <Icon name={course.icon} />,
            density: "drawer",
            heading: course.name,
            info: <Typography>{course.completionPercentage}%</Typography>,
            childItems: course.topics.map((topic) => ({
              id: topic.id,
              heading: topic.name,
              avatar: <Avatar icon={topic.icon} />,
              density: "drawer",
              childItems: [],
            })),
          }))}
        />
      </div>
    </InfoDrawerSection>
  );
};

export default CourseProgressSection;
